var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"base-svg-icon",attrs:{"width":_vm.sWidth,"height":_vm.sHeight,"viewBox":_vm.sViewBox,"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.svgDom)}})}
var staticRenderFns = []

export { render, staticRenderFns }